// extracted by mini-css-extract-plugin
export default {"root":"Collection_root__2Pn8U","onlyCollections":"Collection_onlyCollections__RP9WT","children":"Collection_children__7Q-mK"};